var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweetPotato(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B9CFC0;}\n\t.st1{fill:#DE7C4F;}\n\t.st2{fill:#AE4F98;}\n\t.st3{fill:#A4613B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.57,66.1c0,0-2.69-2.08-4.9-1.59c-2.21,0.49-5.94,1.29-11.12,1.3c-5.18,0.01-17.35,3.45-24.2,12.63 c-6.85,9.18-13.73,19.31-16.94,27.64c-3.21,8.33-6.83,12.11-6.66,17.4c0.18,5.28,0.47,19.63-0.1,21.93c-0.57,2.3-3.08,2.44-2.18,5 c0.9,2.56,1.42,1.88,5.82-2.04c4.41-3.92,7.89-6,10.11-6.26c2.22-0.26,24.4-8.96,30.54-15.72c6.14-6.76,19.62-28.71,19.27-36.13 c-0.35-7.42-1.3-13.18-0.27-16.73C138.99,69.98,140.37,67.16,138.57,66.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.23,76.22c0.96-1.05,2.01-2.04,3.12-2.88c1.74,1.98,6.93,7.35,10.23,8.37c1.14,0.33,1.77,1.53,1.41,2.64 c-0.24,0.84-0.96,1.41-1.8,1.5c-0.27,0.03-0.54,0-0.84-0.09C107.43,84.29,101.28,77.36,100.23,76.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.74,125.03c0.42,0,0.81,0.12,1.11,0.33c-0.33,0.36-0.63,0.72-0.9,1.02c-0.81,0.87-1.86,1.77-3.12,2.7 c-9.63-1.2-13.47-8.58-13.65-8.94c-0.51-1.02-0.12-2.31,0.93-2.82c1.05-0.54,2.31-0.12,2.85,0.9 C106.11,118.55,109.65,125.12,118.74,125.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.02,115.25l-2.4,3.66c-14.76-0.33-20.52-11.4-20.76-11.91c-0.54-1.05-0.12-2.31,0.93-2.85 c1.05-0.51,2.31-0.09,2.85,0.93c0.21,0.42,5.16,9.75,17.94,9.63C126.12,114.71,126.63,114.89,127.02,115.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.02,115.25l-2.4,3.66c-14.76-0.33-20.52-11.4-20.76-11.91c-0.54-1.05-0.12-2.31,0.93-2.85 c1.05-0.51,2.31-0.09,2.85,0.93c0.21,0.42,5.16,9.75,17.94,9.63C126.12,114.71,126.63,114.89,127.02,115.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.85,125.36c-0.33,0.36-0.63,0.72-0.9,1.02c-0.81,0.87-1.86,1.77-3.12,2.7 c-9.63-1.2-13.47-8.58-13.65-8.94c-0.51-1.02-0.12-2.31,0.93-2.82c1.05-0.54,2.31-0.12,2.85,0.9c0.15,0.33,3.69,6.9,12.78,6.81 C119.16,125.03,119.55,125.15,119.85,125.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.99,84.35c-0.24,0.84-0.96,1.41-1.8,1.5c-0.27,0.03-0.54,0-0.84-0.09c-4.92-1.47-11.07-8.4-12.12-9.54 l3.12-2.88c1.74,1.98,6.93,7.35,10.23,8.37C114.72,82.04,115.35,83.24,114.99,84.35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweetPotato);
export default __webpack_public_path__ + "static/media/Sweet_potato.7af6dc1ea813daf4c76ead7bab90e23b.svg";
export { ForwardRef as ReactComponent };